type ProgressBarProps = {
  progress: number; // 0 - 1
};

export const ProgressBar: React.FC<ProgressBarProps> = (props) => {
  const { progress } = props;

  const percentage = Math.round(progress * 100);
  const remainingPercentage = 100 - percentage;

  return (
    <div className="w-full flex items-center justify-between gap-x-4">
      <div className="text-[#00a369] text-sm font-normal">{percentage}%</div>
      <div className="w-full h-1 bg-[#ffffff29] rounded flex">
        <div
          className="h-1 bg-[#00a369] rounded-lg"
          style={{ width: `${percentage}%` }}
        />
        <div
          className="h-1 bg-[#F2F2F2] rounded-lg"
          style={{ width: `${remainingPercentage}%` }}
        />
      </div>
    </div>
  );
};
